
// import { useEffect, useState } from "react";
// import { Avatar, Typography, makeStyles } from "@material-ui/core";
// import { Divider, Grid, Card, Container } from "@mui/material";
// import Loading from "../../../load/loading";
// import Date from "../../../utils/date";
// import api from "../../../services/api";
// import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
// import CreateNoticia from "./createNoticia";
// import MessageSuccess from '../../../messages/messageSuccess';
// import MessageError from "../../../messages/messageError";
// import HeaderSession from "../../../utils/headerSession";
// import HeaderGestorConfigs from "../../../utils/headerGestorConfigs";
// import DeleteNoticia from "./deleteNoticia";
// import { IconButton } from "@mui/material";
// import CloseIcon from '@mui/icons-material/Close';
// import ViewNoticia from '../../../pages/home/noticias/viewNoticia';
// import RegisterAccess from "../../../utils/registerAccess";
// // import RegisterAccess from "../../../utils/registerAccess";

// const useStyles = makeStyles({
//     img: {
//         borderRadius: 5,
//         transition: '1s',
//         '&:hover': { opacity: 0.7, }
//     },

//     root: {
//         transition: '.3s',
//         '&:hover': { width: 25 },
//     },
// })

// export default function GestNoticias() {
//     const classes = useStyles()
//     const [title, setTitle] = useState('Criação')
//     const [noticias, setNoticias] = useState('')
//     const [editarNoticia, setEditarNoticia] = useState(false)
//     const [createNoticia, setCreateNoticia] = useState(false)
//     const [message, setMessage] = useState('')
//     const [messageError, seterrorMessage] = useState('')
//     const [forceUpdate, setForceUpdate] = useState('')
//     const [preview, setPreview] = useState(false)


//     useEffect(() => {
//         api.get(`/noticias?perPage=100`)
//             .then(response => {
//                 // console.log(response)
//                 setNoticias(response.data.noticias);
//             }).catch(error => {
//                 // console.log(error)
//             })
//     }, [editarNoticia, createNoticia, forceUpdate])

//     const HandleEdit = (noticia) => {
//         setEditarNoticia(noticia)
//         setTitle('Editar notícia')
//     }

//     const GridItem = ({ noticia }) => {
//         return (
//             <div key={noticia._id}  >
//                 <RegisterAccess page={'noticias'} />
//                 <Grid container >

//                     <Grid item md={'auto'} onClick={() => setPreview(noticia)}>
//                         <p>{noticia?.seccao}</p>
//                         <Avatar src={noticia.imagem} style={{ width: 300, height: 150 }} variant="square" className={classes.img} />
//                     </Grid>

//                     <Grid item md={8} m style={{ position: 'relative' }}>
//                         <br />
//                         {noticia?.categoria &&
//                             <Typography style={{ color: '#fff', marginBottom: 10, background: '#85287e', display: 'inline-block', padding: 3, borderRadius: 2 }}>
//                                 {noticia.categoria}
//                             </Typography>
//                         }
//                         <Typography variant="subtitle1" style={{ lineHeight: 1, fontSize: 16, marginBottom: 5 }}>
//                             <strong>{noticia.titulo} </strong>
//                         </Typography>

//                         {noticia?.subTitulo &&
//                             <Typography noWrap variant="subtitle2" style={{ lineHeight: 1, fontSize: 15, marginBottom: 5, maxWidth: '70vw' }}>
//                                 {noticia.subTitulo}
//                             </Typography>
//                         }

//                         <Typography variant="subtitle2" style={{ lineHeight: 1, fontSize: 10 }}>
//                             Data: <Date date={noticia.createdAt} />
//                             <br />
//                             Fonte: {noticia.fonte}
//                         </Typography>
//                         <br />
//                         <Typography noWrap variant="body2" style={{ lineHeight: 1, fontSize: 13, maxWidth: '70vw' }}>
//                             {noticia.conteudo}
//                         </Typography>

//                         <div style={{ display: 'flex', alignItems: 'center', position: 'absolute', right: 0, top: 0 }}>
//                             {noticia.status === "Inactivo" &&
//                                 <small style={{ color: 'red' }}> Não publicado</small>
//                             }
//                             <HeaderGestorConfigs
//                                 menu={true}
//                                 configArea={'noticia'}
//                                 title={''}
//                                 noticia={noticia}
//                                 HandleEdit={HandleEdit}
//                             />
//                             <DeleteNoticia
//                                 noticiaId={noticia._id}
//                                 setMessageSuccess={setMessage}
//                                 setMessageError={seterrorMessage}
//                                 setForceUpdate={setForceUpdate}
//                             />
//                         </div>
//                     </Grid>
//                 </Grid>

//                 <Divider />
//                 <br />
//             </div>
//         );
//     };

//     return (
//         <Container>
//             <HeaderSession title={'GESTÃO DE NOTICIAS'} />

//             {message && <MessageSuccess message={message} />}
//             {messageError && < MessageError message={messageError} />}

//             {!preview ?
//                 <Card style={{ minHeight: '95vh', padding: 20 }}>

//                     {/* COMPONENTE DE CRIACAO DE NOTICIAS  */}
//                     {createNoticia &&
//                         <CreateNoticia
//                             title={title}
//                             setTitle={setTitle}
//                             setCreateNoticia={setCreateNoticia}
//                             setMessage={setMessage}
//                             seterrorMessage={seterrorMessage}
//                         />
//                     }
//                     {/*USANDO O MESMO COMPONENTE DE CRIACAO DE NOTICIAS PARA FAZER EDIÇOES DE NOTICIAS */}
//                     {editarNoticia &&
//                         <CreateNoticia
//                             title={title}
//                             setTitle={setTitle}
//                             noticia={editarNoticia}
//                             setEditarNoticia={setEditarNoticia}
//                             setMessage={setMessage}
//                             seterrorMessage={seterrorMessage}
//                         />
//                     }

//                     {(noticias.length > 0 && !editarNoticia && !createNoticia) &&
//                         <>
//                             <Grid container >
//                                 <Grid m xs={12} md item >
//                                     <Typography align="center" style={{ fontSize: 18, margin: 10 }} noWrap variant='h1'>
//                                         Ultima publicação
//                                     </Typography>

//                                     <Avatar src={noticias[0].imagem} style={{ width: 'auto', height: '19em' }} variant="square" className={classes.img} />
//                                     {noticias[0]?.categoria &&
//                                         <Typography style={{ color: '#fff', marginTop: 10, background: '#85287e', display: 'inline-block', padding: 3, borderRadius: 2 }}>
//                                             {noticias[0].categoria}
//                                         </Typography>
//                                     }
//                                     <Typography variant="subtitle1" style={{ lineHeight: 1, fontSize: 20 }}>
//                                         <strong> {noticias[0].titulo} </strong>
//                                     </Typography>
//                                     {noticias[0]?.subTitulo &&
//                                         <Typography noWrap variant="subtitle2" style={{ lineHeight: 1, fontSize: 15, marginBottom: 5, maxWidth: '70vw' }}>
//                                             {noticias[0].subTitulo}
//                                         </Typography>
//                                     }

//                                     <Typography variant="subtitle2" style={{ lineHeight: 1, fontSize: 10 }}>
//                                         Data: <Date date={noticias[0].createdAt} />
//                                         <br />
//                                         Fonte: {noticias[0].fonte}
//                                     </Typography>
//                                 </Grid>

//                                 <Grid xs={12} md={4} item   alignContent={'center'}>
//                                     <Typography align="center" variant="subtitle1" >
//                                         <IconButton onClick={() => { setCreateNoticia(true) }}>
//                                             <AddCircleOutlineIcon style={{ fontSize: 70 }} color="secondary" />
//                                         </IconButton>
//                                         <br />
//                                         ADICIONAR NOVA NOTICIA
//                                     </Typography>
//                                 </Grid>
//                             </Grid>

//                             <Divider />
//                             <br />

//                             <Grid m xs={12} md item >
//                                 {noticias.map((noticia, index) => (
//                                     // (index < (noticias.length / 2)) &&
//                                     <GridItem key={noticia._id} noticia={noticia} />
//                                 ))}
//                             </Grid>
//                         </>
//                     }

//                     {!noticias && <Loading text={'A carregar noticias'} />}
//                 </Card>
//                 :
//                 //  PREVIEW 
//                 <Card style={{ padding: 10 }}>
//                     <IconButton size='small' color='error' style={{ marginRight: 10 }} onClick={() => setPreview(false)}>
//                         <CloseIcon />
//                     </IconButton>

//                     <ViewNoticia preview={preview} />
//                 </Card>
//             }
//         </Container>
//     )
// }


import {
    Avatar,
    Box,
    Button,
    Card,
    Chip,
    Container,
    Divider,
    Grid,
    IconButton,
    InputAdornment,
    Paper,
    TextField,
    Typography,
    Fade,
    Tooltip
} from "@mui/material";

import {
    AddCircleOutline,
    Close,
    Edit,
    Visibility,
    Search,
    Article,
    Public,
    Schedule
} from "@mui/icons-material";

import { makeStyles } from "@material-ui/core";
import { useEffect, useMemo, useState } from "react";

import api from "../../../services/api";
import Loading from "../../../load/loading";

import CreateNoticia from "./createNoticia";
import DeleteNoticia from "./deleteNoticia";
import ViewNoticia from "../../../pages/home/noticias/viewNoticia";

import MessageSuccess from "../../../messages/messageSuccess";
import MessageError from "../../../messages/messageError";

import HeaderSession from "../../../utils/headerSession";
import HeaderGestorConfigs from "../../../utils/headerGestorConfigs";
import RegisterAccess from "../../../utils/registerAccess";
import Date from "../../../utils/date";

const useStyles = makeStyles(() => ({
    image: {
        transition: "0.4s ease",
        objectFit: "cover",
        borderRadius: 16,

        "&:hover": {
            transform: "scale(1.03)",
        },
    },

    cardHover: {
        transition: "0.3s ease",
        cursor: "pointer",

        "&:hover": {
            transform: "translateY(-4px)",
            boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
        },
    },
}));

export default function GestNoticias() {

    const classes = useStyles();

    const [title, setTitle] = useState("Criação");
    const [noticias, setNoticias] = useState([]);
    const [editarNoticia, setEditarNoticia] = useState(false);
    const [createNoticia, setCreateNoticia] = useState(false);

    const [message, setMessage] = useState("");
    const [messageError, seterrorMessage] = useState("");

    const [forceUpdate, setForceUpdate] = useState(false);

    const [preview, setPreview] = useState(false);

    const [loading, setLoading] = useState(true);

    const [search, setSearch] = useState("");

    useEffect(() => {
        setLoading(true);

        api.get(`/noticias?perPage=100`)
            .then((response) => {
                setNoticias(response.data.noticias || []);
            })
            .catch(() => {
                setNoticias([]);
            })
            .finally(() => {
                setLoading(false);
            });

    }, [editarNoticia, createNoticia, forceUpdate]);

    const HandleEdit = (noticia) => {
        setEditarNoticia(noticia);
        setTitle("Editar notícia");
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    const noticiasFiltradas = useMemo(() => {

        return noticias.filter((noticia) => {

            const texto = `
                ${noticia?.titulo || ""}
                ${noticia?.subTitulo || ""}
                ${noticia?.categoria || ""}
                ${noticia?.fonte || ""}
            `.toLowerCase();

            return texto.includes(search.toLowerCase());

        });

    }, [noticias, search]);

    const ultimaNoticia = noticiasFiltradas[0];

    const CardNoticia = ({ noticia }) => {

        return (
            <Fade in timeout={300}>
                <Card
                    elevation={0}
                    className={classes.cardHover}
                    sx={{
                        borderRadius: 5,
                        overflow: "hidden",
                        border: "1px solid #ececec",
                        mb: 3,
                        background: "#fff",
                    }}
                >
                    <Grid container>

                        {/* IMAGEM */}
                        <Grid item xs={12} md={4}>
                            <Box
                                onClick={() => setPreview(noticia)}
                                sx={{
                                    position: "relative",
                                    height: "100%",
                                    minHeight: 250,
                                    overflow: "hidden",
                                    cursor: "pointer",
                                }}
                            >
                                <Avatar
                                    src={noticia?.imagem}
                                    variant="square"
                                    className={classes.image}
                                    sx={{
                                        width: "100%",
                                        height: "100%",
                                    }}
                                />

                                <Box
                                    sx={{
                                        position: "absolute",
                                        inset: 0,
                                        background:
                                            "linear-gradient(to top, rgba(0,0,0,0.55), transparent)",
                                    }}
                                />

                                <Chip
                                    label={noticia?.categoria || "OUTROS"}
                                    size="small"
                                    sx={{
                                        position: "absolute",
                                        top: 15,
                                        left: 15,
                                        background: "#85287e",
                                        color: "#fff",
                                        fontWeight: 600,
                                    }}
                                />

                                {noticia?.status === "Inactivo" && (
                                    <Chip
                                        label="Não publicado"
                                        size="small"
                                        color="error"
                                        sx={{
                                            position: "absolute",
                                            bottom: 15,
                                            left: 15,
                                            fontWeight: 600,
                                        }}
                                    />
                                )}
                            </Box>
                        </Grid>

                        {/* CONTEÚDO */}
                        <Grid item xs={12} md={8}>

                            <Box
                                sx={{
                                    p: 3,
                                    height: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "space-between",
                                }}
                            >

                                <Box>

                                    <Typography
                                        variant="h6"
                                        sx={{
                                            fontWeight: 800,
                                            color: "#1e1e1e",
                                            mb: 1,
                                            lineHeight: 1.3,
                                        }}
                                    >
                                        {noticia?.titulo}
                                    </Typography>

                                    {noticia?.subTitulo && (
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                color: "#666",
                                                mb: 2,
                                                lineHeight: 1.6,
                                            }}
                                        >
                                            {noticia?.subTitulo}
                                        </Typography>
                                    )}

                                    <Typography
                                        variant="body2"
                                        sx={{
                                            color: "#555",
                                            lineHeight: 1.8,
                                            display: "-webkit-box",
                                            overflow: "hidden",
                                            WebkitLineClamp: 3,
                                            WebkitBoxOrient: "vertical",
                                        }}
                                    >
                                        {noticia?.conteudo?.replace(/<[^>]+>/g, "")}
                                    </Typography>

                                </Box>

                                <Box
                                    sx={{
                                        mt: 3,
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        flexWrap: "wrap",
                                        gap: 2,
                                    }}
                                >

                                    <Box
                                        sx={{
                                            display: "flex",
                                            gap: 3,
                                            flexWrap: "wrap",
                                        }}
                                    >

                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                            <Schedule sx={{ fontSize: 18, color: "#777" }} />
                                            <Typography variant="caption">
                                                <Date date={noticia?.createdAt} />
                                            </Typography>
                                        </Box>

                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                            <Public sx={{ fontSize: 18, color: "#777" }} />
                                            <Typography variant="caption">
                                                {noticia?.fonte}
                                            </Typography>
                                        </Box>

                                    </Box>

                                    <Box sx={{ display: "flex", alignItems: "center" }}>

                                        <Tooltip title="Visualizar">
                                            <IconButton
                                                color="primary"
                                                onClick={() => setPreview(noticia)}
                                            >
                                                <Visibility />
                                            </IconButton>
                                        </Tooltip>

                                        <Tooltip title="Editar">
                                            <IconButton
                                                color="secondary"
                                                onClick={() => HandleEdit(noticia)}
                                            >
                                                <Edit />
                                            </IconButton>
                                        </Tooltip>

                                        <HeaderGestorConfigs
                                            menu={true}
                                            configArea={"noticia"}
                                            title={""}
                                            noticia={noticia}
                                            HandleEdit={HandleEdit}
                                        />

                                        <DeleteNoticia
                                            noticiaId={noticia?._id}
                                            setMessageSuccess={setMessage}
                                            setMessageError={seterrorMessage}
                                            setForceUpdate={setForceUpdate}
                                        />

                                    </Box>

                                </Box>

                            </Box>

                        </Grid>

                    </Grid>
                </Card>
            </Fade>
        );
    };

    return (
        <Container maxWidth="xl" sx={{ py: 4 }}>

            <RegisterAccess page={"noticias"} />

            <HeaderSession title={"GESTÃO DE NOTÍCIAS"} />

            {message && <MessageSuccess message={message} />}
            {messageError && <MessageError message={messageError} />}

            {!preview ? (

                <Card
                    elevation={0}
                    sx={{
                        minHeight: "90vh",
                        borderRadius: 6,
                        overflow: "hidden",
                        border: "1px solid #ececec",
                        background:
                            "linear-gradient(to bottom, #ffffff, #fafafa)",
                    }}
                >

                    {/* HEADER */}
                    <Box
                        sx={{
                            p: 4,
                            background:
                                "linear-gradient(135deg, #85287e, #5e1d59)",
                            color: "#fff",
                        }}
                    >

                        <Grid container spacing={3} alignItems="center">

                            <Grid item xs={12} md>

                                <Typography
                                    variant="h4"
                                    sx={{
                                        fontWeight: 900,
                                        mb: 1,
                                    }}
                                >
                                    Painel de Notícias
                                </Typography>

                                <Typography variant="body1" sx={{ opacity: 0.9 }}>
                                    Gerencie, publique e acompanhe todas as notícias da plataforma.
                                </Typography>

                            </Grid>

                            <Grid item xs={12} md="auto">

                                <Button
                                    startIcon={<AddCircleOutline />}
                                    variant="contained"
                                    size="large"
                                    onClick={() => {
                                        setCreateNoticia(true);
                                        setEditarNoticia(false);
                                        setTitle("Criação");
                                    }}
                                    sx={{
                                        background: "#fff",
                                        color: "#85287e",
                                        fontWeight: 700,
                                        px: 3,
                                        py: 1.2,
                                        borderRadius: 3,

                                        "&:hover": {
                                            background: "#f3f3f3",
                                        },
                                    }}
                                >
                                    Nova Notícia
                                </Button>

                            </Grid>

                        </Grid>

                    </Box>

                    {/* FORM */}
                    {(createNoticia || editarNoticia) && (
                        <Box sx={{ p: 4 }}>
                            <CreateNoticia
                                title={title}
                                setTitle={setTitle}
                                noticia={editarNoticia || undefined}
                                setEditarNoticia={setEditarNoticia}
                                setCreateNoticia={setCreateNoticia}
                                setMessage={setMessage}
                                seterrorMessage={seterrorMessage}
                            />
                        </Box>
                    )}

                    {/* LISTAGEM */}
                    {!createNoticia && !editarNoticia && (

                        <Box sx={{ p: 4 }}>

                            {/* PESQUISA */}
                            <Paper
                                elevation={0}
                                sx={{
                                    p: 1,
                                    mb: 4,
                                    borderRadius: 4,
                                    border: "1px solid #e5e5e5",
                                }}
                            >

                                <TextField
                                    fullWidth
                                    placeholder="Pesquisar notícias..."
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                    variant="standard"
                                    InputProps={{
                                        disableUnderline: true,
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Search />
                                            </InputAdornment>
                                        ),
                                    }}
                                />

                            </Paper>

                            {/* DESTAQUE */}
                            {ultimaNoticia && (

                                <Card
                                    elevation={0}
                                    sx={{
                                        borderRadius: 5,
                                        overflow: "hidden",
                                        mb: 5,
                                        background:
                                            "linear-gradient(135deg, #f8f8f8, #ffffff)",
                                        border: "1px solid #ececec",
                                    }}
                                >

                                    <Grid container>

                                        <Grid item xs={12} md={6}>
                                            <Box
                                                sx={{
                                                    height: "100%",
                                                    minHeight: 350,
                                                    overflow: "hidden",
                                                    cursor: "pointer",
                                                }}
                                                onClick={() => setPreview(ultimaNoticia)}
                                            >
                                                <img
                                                    src={ultimaNoticia?.imagem}
                                                    alt={ultimaNoticia?.titulo}
                                                    className={classes.image}
                                                    style={{
                                                        width: "100%",
                                                        height: "100%",
                                                    }}
                                                />
                                            </Box>
                                        </Grid>

                                        <Grid item xs={12} md={6}>
                                            <Box
                                                sx={{
                                                    p: 5,
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    justifyContent: "center",
                                                    height: "100%",
                                                }}
                                            >

                                                <Chip
                                                    icon={<Article />}
                                                    label="Última publicação"
                                                    sx={{
                                                        width: "fit-content",
                                                        mb: 2,
                                                        background: "#85287e",
                                                        color: "#fff",
                                                        fontWeight: 700,
                                                    }}
                                                />

                                                <Typography
                                                    variant="h4"
                                                    sx={{
                                                        fontWeight: 900,
                                                        mb: 2,
                                                        lineHeight: 1.3,
                                                    }}
                                                >
                                                    {ultimaNoticia?.titulo}
                                                </Typography>

                                                <Typography
                                                    variant="body1"
                                                    sx={{
                                                        color: "#666",
                                                        lineHeight: 1.8,
                                                        mb: 3,
                                                    }}
                                                >
                                                    {ultimaNoticia?.subTitulo}
                                                </Typography>

                                                <Button
                                                    variant="contained"
                                                    onClick={() => setPreview(ultimaNoticia)}
                                                    sx={{
                                                        width: "fit-content",
                                                        background: "#85287e",
                                                        borderRadius: 3,
                                                        px: 4,

                                                        "&:hover": {
                                                            background: "#6e2168",
                                                        },
                                                    }}
                                                >
                                                    Ler notícia
                                                </Button>

                                            </Box>
                                        </Grid>

                                    </Grid>

                                </Card>
                            )}

                            {/* LISTA */}
                            {loading ? (
                                <Loading text={"A carregar notícias"} />
                            ) : noticiasFiltradas.length > 0 ? (
                                noticiasFiltradas.map((noticia) => (
                                    <CardNoticia
                                        key={noticia._id}
                                        noticia={noticia}
                                    />
                                ))
                            ) : (
                                <Typography
                                    align="center"
                                    sx={{
                                        py: 10,
                                        color: "#999",
                                        fontWeight: 600,
                                    }}
                                >
                                    Nenhuma notícia encontrada.
                                </Typography>
                            )}

                        </Box>
                    )}

                </Card>

            ) : (

                /* PREVIEW */

                <Card
                    elevation={0}
                    sx={{
                        borderRadius: 5,
                        overflow: "hidden",
                        border: "1px solid #ececec",
                    }}
                >

                    <Box
                        sx={{
                            p: 2,
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            borderBottom: "1px solid #eee",
                            background: "#fafafa",
                        }}
                    >

                        <Typography fontWeight={700}>
                            Preview da notícia
                        </Typography>

                        <IconButton
                            color="error"
                            onClick={() => setPreview(false)}
                        >
                            <Close />
                        </IconButton>

                    </Box>

                    <Box sx={{ p: 2 }}>
                        <ViewNoticia preview={preview} />
                    </Box>

                </Card>

            )}

        </Container>
    );
}